export const useProductImageFallback = (event) => {
  const image = event.currentTarget;
  if (image.dataset.fallbackApplied) return;
  image.dataset.fallbackApplied = "true";
  image.src = "/logo-ROMI-fondo.png";
  image.classList.add("image-fallback");
};
